<template>
  <ion-item lines="none">
    <ion-select
      :ok-text="$t('confirm')"
      :cancel-text="$t('cancel')"
      :value="selectData.value"
      :interface="interfaceFlag"
      :interface-options="interfaceFlag !== 'popover' ? alertOptions : false"
      :label="selectData.title"
      label-placement="floating"
      :disabled="selectData.disabled"
      @ion-change="$emit('update:value', handleInputChange($event))"
    >
      <ion-select-option v-for="item in selectData.options" :key="`option_${item}`" :value="item.value">
        {{ item.title }}
      </ion-select-option>
    </ion-select>
  </ion-item>
</template>

<script lang="ts" setup>
import type { SelectInterface } from '@ionic/core';
import { IonItem, IonSelect, IonSelectOption } from '@ionic/vue';
import type { PropType } from 'vue';
import type { FormSelectDataModel } from '@/types';

const props = defineProps({
  value: {
    type: [String, Number],
    required: true,
  },
  selectData: {
    type: Object as PropType<FormSelectDataModel>,
    required: true,
  },
  interfaceFlag: {
    type: String as PropType<SelectInterface>,
    default: '',
  },
});

defineEmits(['update:value']);

const alertOptions: any = {
  header: props.selectData.title,
  cssClass: 'custom-select-alert',
};

const handleInputChange = (event: Event) => (event.target as HTMLSelectElement).value;
</script>

<style scoped lang="scss">
ion-item {
  --padding-start: 1rem;
  --padding-end: 1rem;
  --inner-padding-end: 0;
  --background: var(--ion-color-light-background-contrast);
  border: 1px solid var(--ion-color-medium);
  border-radius: app-radius(md);
  --min-height: 0;
}
ion-item::part(native) {
  border-radius: app-radius(md);
}
ion-select {
  --highlight-color-focused: var(--ion-color-medium);
}
</style>
